import React from 'react';
import OrderCard from './OrderCard';
import { format, isToday, isYesterday } from 'date-fns';

const OrderHistoryList = ({ 
  orders, 
  expandedOrders, 
  onToggleExpand, 
  onReorder, 
  onViewDetails, 
  onGetHelp 
}) => {
  if (!orders || orders.length === 0) {
    return null;
  }

  // Group orders by date string YYYY-MM-DD
  const groupedOrders = orders.reduce((groups, order) => {
    const rawDate = order.created_at || order.createdAt;
    const dateObj = rawDate ? new Date(rawDate) : new Date();
    const dateKey = format(dateObj, 'yyyy-MM-dd');
    if (!groups[dateKey]) {
      groups[dateKey] = {
        dateObj,
        orders: []
      };
    }
    groups[dateKey].orders.push(order);
    return groups;
  }, {});

  const formatDateHeader = (dateObj) => {
    if (isToday(dateObj)) {
      return `Today • ${format(dateObj, 'dd MMM yyyy')}`;
    }
    if (isYesterday(dateObj)) {
      return `Yesterday • ${format(dateObj, 'dd MMM yyyy')}`;
    }
    return format(dateObj, 'EEEE, dd MMMM yyyy');
  };

  return (
    <div className="space-y-4">
      {Object.entries(groupedOrders)
        .sort(([dateA], [dateB]) => new Date(dateB) - new Date(dateA))
        .map(([dateKey, group]) => (
          <section key={dateKey} className="space-y-2.5">
            {/* Sticky Date Header with count badge */}
            <div className="sticky top-[105px] z-10 bg-gray-50/95 backdrop-blur-md py-1 flex items-center justify-between">
              <span className="text-[11px] font-black text-gray-500 uppercase tracking-wider flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 rounded-full bg-gray-400" />
                {formatDateHeader(group.dateObj)}
              </span>
              <span className="text-[10px] font-bold text-gray-400 px-2 py-0.5 rounded-full bg-gray-200/60">
                {group.orders.length} {group.orders.length === 1 ? 'order' : 'orders'}
              </span>
            </div>

            {/* List of Orders for this date */}
            <div className="space-y-2.5">
              {group.orders.map((order) => (
                <OrderCard
                  key={order.id}
                  order={order}
                  isExpanded={expandedOrders?.includes(order.id)}
                  onToggleExpand={onToggleExpand}
                  onReorder={onReorder}
                  onViewDetails={onViewDetails}
                  onGetHelp={onGetHelp}
                />
              ))}
            </div>
          </section>
        ))}
    </div>
  );
};

export default OrderHistoryList;